<div class="view-component">
  <div class="content">

    <!-- ============ Barra superior ============ -->
    <div class="toolbar">
      <div class="toolbar__company" *ngIf="listOfCompanies.length > 1">
        <nz-select [(ngModel)]="codecompany"
                   (ngModelChange)="clearFilters(); enableFilters()"
                   [nzPlaceHolder]="'melidownload.escolherempresa' | translateTA"
                   nzShowSearch>
          <nz-option *ngFor="let data of listOfCompanies"
                     [nzValue]="data.codecompany"
                     [nzLabel]="data.codecompany + ' - ' + data.companyname">
          </nz-option>
        </nz-select>
      </div>

      <div class="toolbar__search" [formGroup]="formInicial">
        <nz-input-group [nzSuffix]="clearSearchTpl">
          <input nz-input formControlName="productSearch"
                 [placeholder]="'melidownload.dadosbusca' | translateTA"
                 type="text" (keydown)="inputChanged()" (keyup)="updateFilter($event)" />
        </nz-input-group>
        <ng-template #clearSearchTpl>
          <span nz-icon nzType="close-circle" nzTheme="fill" class="clear-icon"
                *ngIf="enableSearch && formInicial.get('productSearch')?.value"
                (click)="formInicial.get('productSearch').setValue(''); clearFilters()"></span>
        </ng-template>
      </div>

      <button nz-button nzType="primary" class="toolbar__go"
              [disabled]="!enableSearch" (click)="pesquisar(false)">
        <span nz-icon nzType="search"></span>
        {{ 'melidownload.pesquisar' | translateTA }}
      </button>

      <label class="toolbar__mode">
        <nz-switch [(ngModel)]="updateMode" (ngModelChange)="changeMode($event)"></nz-switch>
        <span>{{ 'melidownload.modoatulizacao' | translateTA }}</span>
      </label>
    </div>

    <!-- ============ Corpo ============ -->
    <div class="melicontainer">

      <!-- ---- Painel esquerdo: resultados ---- -->
      <div class="panel panel--results" [class.panel--full]="updateMode">
        <nz-spin [nzSpinning]="loadingResults" nzSize="large" class="results-spin">

        <div class="information">
          <div class="information__count" *ngIf="!updateMode">
            {{ 'melidownload.exibindo' | translateTA }} <strong>{{ meliTempItens.length }}</strong>
            {{ 'melidownload.de' | translateTA }} <strong>{{ paging['total'] }}</strong>
            {{ 'melidownload.resultados' | translateTA }}
          </div>
          <div class="information__count" *ngIf="updateMode">
            {{ 'melidownload.selecionado' | translateTA }}
            <strong>{{ (meliItens | arrayFilter:'checked':'true':false).length }}</strong>
            {{ 'melidownload.de' | translateTA }}
            <strong>{{ paging['total'] == null ? 0 : paging['total'] }}</strong>
            {{ 'melidownload.resultados' | translateTA }}
          </div>

          <div class="information__actions" *ngIf="!updateMode && loading">
            <button nz-button nzDanger (click)="cancelLoading()">
              {{ 'melidownload.parar' | translateTA }}
            </button>
          </div>

          <div class="information__actions" *ngIf="updateMode">
            <nz-select [(ngModel)]="importados" class="importados-select">
              <nz-option [nzValue]="false" [nzLabel]="'melidownload.naoimportados' | translateTA"></nz-option>
              <nz-option [nzValue]="true"  [nzLabel]="'melidownload.importados' | translateTA"></nz-option>
            </nz-select>

            <span class="vl"></span>

            <button nz-button nzType="primary" [disabled]="meliItens.length == 0" (click)="pesquisar(true)">
              <span nz-icon nzType="search"></span>{{ 'melidownload.carregarpagina' | translateTA }}
            </button>

            <span class="vl"></span>

            <button nz-button [disabled]="meliItens.length == 0" (click)="acaoAlterar(true)">
              <span nz-icon nzType="check-square"></span>{{ 'melidownload.marcartodos' | translateTA }}
            </button>
            <button nz-button [disabled]="meliItens.length == 0" (click)="acaoAlterar(false)">
              <span nz-icon nzType="border"></span>{{ 'melidownload.desmarcartodos' | translateTA }}
            </button>

            <span class="vl"></span>

            <button nz-button nzType="primary" [disabled]="meliItens.length == 0" (click)="processar()">
              {{ 'melidownload.processar' | translateTA }}
            </button>
          </div>
        </div>

        <div class="detail">
          <div class="cards-grid">
            <ng-container *ngFor="let meli of meliTempItens">
              <meli-item *ngIf="!updateMode" [melidata]="meli"
                         (select)="selectProduct($event)" [codeCompany]="codecompany"></meli-item>
              <ng-container *ngIf="updateMode"
                            [ngTemplateOutlet]="main"
                            [ngTemplateOutletContext]="{ $implicit: meli }"></ng-container>
            </ng-container>
          </div>
        </div>
        </nz-spin>
      </div>

      <!-- ---- Painel direito: filtros ---- -->
      <aside class="panel panel--filters" *ngIf="!updateMode">
        <nz-input-group [nzSuffix]="clearTitleTpl">
          <input nz-input [formControl]="findtitle"
                 [placeholder]="'melidownload.buscatitle' | translateTA"
                 (keyup)="updateFilterGeneric()" type="text" />
        </nz-input-group>
        <ng-template #clearTitleTpl>
          <span nz-icon nzType="close-circle" nzTheme="fill" class="clear-icon"
                *ngIf="findtitle.value" (click)="findtitle.setValue(''); updateFilterGeneric()"></span>
        </ng-template>

        <nz-input-group [nzSuffix]="clearMlbTpl">
          <input nz-input [formControl]="findmlb"
                 [placeholder]="'melidownload.buscamlb' | translateTA"
                 (keyup)="updateFilterGeneric()" type="text" />
        </nz-input-group>
        <ng-template #clearMlbTpl>
          <span nz-icon nzType="close-circle" nzTheme="fill" class="clear-icon"
                *ngIf="findmlb.value" (click)="findmlb.setValue(''); updateFilterGeneric()"></span>
        </ng-template>

        <nz-divider nzPlain [nzText]="'filter.variation' | translateTA"></nz-divider>
        <nz-radio-group [(ngModel)]="withVariation" (ngModelChange)="updateFilterGeneric()"
                        class="filter-radio-group">
          <label nz-radio *ngFor="let d of listTipVariacoes" [nzValue]="d.key">
            {{ d.value | translateTA }}
          </label>
        </nz-radio-group>

        <nz-divider nzPlain [nzText]="'filter.relation' | translateTA"></nz-divider>
        <nz-radio-group [(ngModel)]="withRelation" (ngModelChange)="updateFilterGeneric()"
                        class="filter-radio-group">
          <label nz-radio *ngFor="let d of listWithRelation" [nzValue]="d.key">
            {{ d.value | translateTA }}
          </label>
        </nz-radio-group>
      </aside>
    </div>
  </div>
</div>

<!-- ============ Card do modo atualização ============ -->
<ng-template #main let-item>
  <div class="update-card"
       [class.update-card--imported]="item.imported"
       nz-tooltip
       [nzTooltipTitle]="item.imported ? ('melidownload.alreadyrelation' | translateTA) : null">
    <div class="update-card__check">
      <rounded-checkbox [(ngModel)]="item.checked" (change)="selectChk($event, item)"></rounded-checkbox>
    </div>
    <div class="update-card__body">
      <div class="update-card__title" nz-tooltip
           [nzTooltipTitle]="item.CODEPRODUCT + ' - ' + item.DESCRPROD">
        {{ item.CODEPRODUCT }} - {{ item.DESCRPROD }}
      </div>
      <div class="update-card__id">{{ item.ID }}</div>
    </div>
    <span class="update-card__badge" *ngIf="item.imported" nz-icon nzType="check-circle" nzTheme="fill"></span>
  </div>
</ng-template>